import React, { ReactNode } from "react";
import { useLockBodyScroll } from "../../../hooks/useLockBodyScroll";

type Props = {
  open?: boolean;
  close?: () => void;
  children: ReactNode;
  bottomSheetStyle?: React.CSSProperties;
};

const BottomSheetContainer = ({
  open,
  close,
  children,
  bottomSheetStyle
}: Props) => {
  useLockBodyScroll(open);

  if (!open) {
    return null;
  }

  return (
    <div
      onClick={close}
      className="fixed top-0 left-0 flex justify-center items-center backdrop-blur-sm bg-opacity-40 bg-[#000000] w-[100%] h-[100%] z-[150] "
      style={{ zIndex: Number.MAX_VALUE }}
    >
      <div
        style={bottomSheetStyle}
        onClick={e => {
          e.stopPropagation();
        }}
        className="w-full bg-white self-end rounded-t-3xl overflow-auto"
      >
        {children}
      </div>
    </div>
  );
};

export default BottomSheetContainer;
